// Miami Multi-Trade Site Data
// All content centralized here for easy management

export const BRAND = {
  commercial: "MIAMI MULTI-TRADE",
  tagline: "ONE CONTRACTOR. MULTIPLE TRADES. INSIDE & OUT.",
  subtitle: "Construction · Remodeling · Planning · Permitting",
  phone: "305-764-4388",
  email: "dvisoconsulting@gmail.com",
  address: "360 NW 27th St, Miami, FL 33127",
};

// Canonical (English) emergency categories — stored in CRM regardless of UI language
export const EMERGENCY_CATEGORIES = [
  "Electrical Emergency",
  "Plumbing Emergency",
  "HVAC / Air Conditioning Emergency",
  "Water Leak / Pipe Break",
  "Drain / Sewer Issue",
  "Urgent Property Repair",
  "Other Emergency",
];

export const SERVICE_CATEGORIES = [
  {
    slug: "remodeling",
    title: "Remodeling",
    desc: "Kitchen, bathroom, whole-home renovations and interior transformations with premium finishes and modern design.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1631048501619-a27088a3bb70?w=800",
    items: ["Kitchen Remodeling", "Bathroom Remodeling", "Whole Home Remodeling", "Interior Renovations", "Home Additions", "Room Transformations"]
  },
  {
    slug: "multi-trade",
    title: "Multi-Trade Services",
    desc: "Plumbing, electrical, HVAC, drywall, flooring, tile, and painting — all coordinated under one contractor.",
    icon: "Wrench",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/lz49ldyn_Imagen%20de%20ChatGPT%2028%20sept%202026%2C%2017_14_31.png",
    items: ["Plumbing", "Electrical", "HVAC / Air Conditioning", "Mechanical", "Drywall", "Flooring", "Tile Installation", "Painting & Finishes", "Structural & Civil Engineering"]
  },
  {
    slug: "outdoor-living",
    title: "Outdoor Living & Entertainment",
    desc: "Outdoor kitchens, pergolas, patios, pool areas and entertainment spaces designed for the Miami lifestyle.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1762117360868-d4e757073d45?w=800",
    items: ["Outdoor Kitchens", "BBQ Areas", "Covered Patios", "Pergolas", "Gazebos", "Outdoor Bars", "Entertainment Areas", "Fire Pits", "Pool Deck Areas", "Exterior Lighting", "Pavers", "Exterior Flooring"]
  },
  {
    slug: "landscape",
    title: "Landscape Design & Exterior",
    desc: "Tropical landscaping, hardscape, irrigation, driveways, walkways, and decorative exterior elements.",
    icon: "Trees",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/489d10502f771aa5_Entrada%20tropical%20de%20lujo%20al%20atardecer.png",
    items: ["Landscape Design", "Landscape Installation", "Hardscape", "Tropical Landscaping", "Artificial Turf", "Pavers", "Walkways", "Driveways", "Exterior Lighting", "Irrigation Coordination", "Drainage Solutions"]
  },
  {
    slug: "construction",
    title: "Construction & Development",
    desc: "Ground-up new construction, residential builds, commercial improvements, additions, and full project management.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?w=800",
    items: ["New Construction", "Residential Construction", "Commercial Improvements", "Home Additions", "Construction Management", "Project Management", "Budgeting", "Project Feasibility", "Pre-Construction Planning"]
  },
  {
    slug: "permitting",
    title: "Planning & Permitting",
    desc: "Permit coordination, code compliance, violation resolution, zoning, and pre-construction planning support.",
    icon: "FileCheck2",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800",
    items: ["Permit Coordination", "Permit Applications", "Permit Expediting", "Permit Reactivation", "Code Compliance Coordination", "Violation Resolution", "Planning Support", "Zoning Coordination", "Inspection Coordination"]
  }
];

export const INSIDE_SERVICES = [
  "Kitchen", "Bathroom", "Flooring", "Electrical", "Plumbing",
  "HVAC", "Drywall", "Interior Renovations"
];

export const OUTSIDE_SERVICES = [
  "Landscape", "Outdoor Kitchen", "BBQ Areas", "Pergolas",
  "Pavers", "Lighting", "Patios", "Entertainment Areas", "Home Additions"
];

export const HOW_IT_WORKS = [
  { num: "01", name: "Tell Us About Your Project", desc: "Share your vision, goals, and project requirements." },
  { num: "02", name: "Upload Photos or Plans", desc: "Upload existing photos, architectural plans, or documents." },
  { num: "03", name: "Project Review", desc: "Our team reviews scope, feasibility, and preliminary budget." },
  { num: "04", name: "Site Visit", desc: "On-site evaluation and detailed measurements." },
  { num: "05", name: "Detailed Estimate", desc: "Comprehensive proposal with scope, timeline, and pricing." },
  { num: "06", name: "Planning & Permitting", desc: "Permit coordination and pre-construction planning if required." },
  { num: "07", name: "Construction", desc: "Coordinated multi-trade execution from start to finish." }
];

export const WHY_US = [
  { title: "One Point of Contact", desc: "A single project manager coordinates all trades and communications." },
  { title: "Multiple Trades", desc: "Plumbing, electrical, HVAC, and more — coordinated under one contractor." },
  { title: "Project Management", desc: "Professional oversight from planning through construction completion." },
  { title: "Permit Coordination", desc: "We navigate the complex permitting process so you don't have to." },
  { title: "Interior + Exterior", desc: "From kitchen renovations to outdoor living — one team, inside and out." },
  { title: "Miami Market Knowledge", desc: "Deep understanding of local codes, materials, and climate requirements." }
];

export const SERVICE_AREAS = [
  "Miami", "Miami Beach", "Coral Gables", "Coconut Grove", "Doral",
  "Pinecrest", "Kendall", "Aventura", "Miami Gardens", "Hialeah"
];

export const BUDGET_RANGES = [
  "Under $10,000", "$10,000 – $25,000", "$25,000 – $50,000",
  "$50,000 – $100,000", "$100,000 – $250,000", "$250,000+", "Not Sure Yet"
];

export const CONTACT_METHODS = ["Call", "Text", "Email", "WhatsApp"];

export const AI_PROJECT_TYPES = [
  "Kitchen", "Bathroom", "Living Area", "Full Interior Renovation",
  "Backyard", "Outdoor Entertainment Area", "Outdoor Kitchen / BBQ",
  "Pergola / Patio", "Landscape Design", "Home Exterior", "Driveway / Pavers"
];

export const AI_STYLES = [
  "Modern", "Contemporary", "Luxury", "Tropical Miami", "Mediterranean", "Minimalist"
];

export const INSPIRATION_IMAGES = [
  { category: "Modern Homes", image: "https://images.unsplash.com/photo-1706164971309-fb4785fe6ceb?w=800", label: "Design Inspiration" },
  { category: "Kitchen Transformations", image: "https://images.unsplash.com/photo-1682888813913-e13f18692019?w=800", label: "Design Inspiration" },
  { category: "Bathroom Remodeling", image: "https://images.unsplash.com/photo-1644068298141-6333cb147520?w=800", label: "Design Inspiration" },
  { category: "Outdoor Living", image: "https://images.unsplash.com/photo-1762117360868-d4e757073d45?w=800", label: "Design Inspiration" },
  { category: "Landscape Design", image: "https://customer-assets-v7afamib.emergentagent.net/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/816b1a5bd5f73781_Luxury%20Tropical%20Patio%20at%20Sunset.png", label: "Design Inspiration" },
  { category: "New Construction", image: "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?w=800", label: "Design Inspiration" },
];

// Existing project images (user's actual completed work - preserved from old site)
export const COMPLETED_PROJECTS_SHOWCASE = [
  {
    title: "Modern Minimalist Home Transformation",
    images: [
      "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/cg526ti7_Image%205-6-26%20at%207.23%E2%80%AFPM.jpeg",
      "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/6fmzq0r3_Image%205-6-26%20at%207.16%E2%80%AFPM.jpeg",
      "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/fd49nqx1_Image%205-6-26%20at%207.19%E2%80%AFPM.jpeg",
      "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/t69r5oik_Image%205-6-26%20at%207.20%E2%80%AFPM.jpeg",
      "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/ab17b2sg_Image%205-6-26%20at%208.06%E2%80%AFPM.jpeg",
    ],
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/cg526ti7_Image%205-6-26%20at%207.23%E2%80%AFPM.jpeg",
    type: "Featured Transformation",
    location: "Miami, FL"
  },
  {
    title: "Complete Property Renovation",
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/t69r5oik_Image%205-6-26%20at%207.20%E2%80%AFPM.jpeg",
    type: "Fix & Flip",
    location: "Miami, FL"
  },
  {
    title: "Renovated Single-Family Home",
    image: "https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/6fmzq0r3_Image%205-6-26%20at%207.16%E2%80%AFPM.jpeg",
    type: "Completed Renovation",
    location: "Miami, FL"
  }
];
